export default __webpack_public_path__ + "static/media/rubik-v12-latin-300.922d228d.ttf";